import React, { useState } from 'react'
import { Box } from '@material-ui/core'
import Modal from '@mui/material/Modal'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { colors, Button } from '@resiliatech/birdsong'
import {
  AddLink,
  AddLinkActions,
  AddLinkButtons,
  CloseModalIconContainer,
  LinkTextField,
  TaskLinkModalContainer,
  TaskLinkModalContent,
} from './TaskLinkManager.styled'

type TaskLinkManagerProps = {
  isOpen: boolean
  onClose: () => void
  onSaveTaskLink: (linkText: string, linkUrl: string) => void
}

export const TaskLinkManager = ({
  isOpen,
  onClose,
  onSaveTaskLink,
}: TaskLinkManagerProps) => {
  const [linkText, setLinkText] = useState('')
  const [linkUrl, setLinkUrl] = useState('')

  const clearInputs = () => {
    setLinkText('')
    setLinkUrl('')
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && linkText && linkUrl) {
      handleSaveTaskLink()
    }
  }

  const handleSaveTaskLink = () => {
    onSaveTaskLink(linkText, linkUrl)
    clearInputs()
    onClose()
  }

  const handleCancel = () => {
    clearInputs()
    onClose()
  }

  return (
    <Box>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <TaskLinkModalContainer>
          <TaskLinkModalContent>
            <CloseModalIconContainer>
              <IconButton onClick={onClose}>
                <CloseIcon sx={{ color: colors.interactive.primaryEnabled }} />
              </IconButton>
            </CloseModalIconContainer>
            <AddLinkActions>
              <AddLink>Add Link</AddLink>
              <LinkTextField
                id='task-add-link-label'
                label='Text'
                variant='outlined'
                onChange={(e) => setLinkText(e.target.value)}
                onKeyPress={handleKeyPress}
                value={linkText}
              />
              <LinkTextField
                id='task-add-link-url'
                label='URL'
                variant='outlined'
                onChange={(e) => setLinkUrl(e.target.value)}
                onKeyPress={handleKeyPress}
                value={linkUrl}
                placeholder='https://www.resilia.com'
              />
            </AddLinkActions>
            <AddLinkButtons>
              <Button
                label='Cancel'
                onClick={handleCancel}
                variant='tertiary'
              />
              <Button
                label='Save'
                onClick={handleSaveTaskLink}
                variant='primary'
              />
            </AddLinkButtons>
          </TaskLinkModalContent>
        </TaskLinkModalContainer>
      </Modal>
    </Box>
  )
}
